
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 1h10v2h1V0H0v12h12V9h-1v2H1V1z","fill":"#8A8888"}}),_c('path',{attrs:{"d":"M6.707 3l2.55 2.549-.002.001.495.45-.494.449.001.001L6.707 9 6 8.293 7.793 6.5H3v-1h4.793L6 3.707 6.707 3z","fill":"#8A8888"}})])
          )
        }
      }
    